export default "__VITE_ASSET__I7yPxnpY__"